<template>
  <page-layout
    :title="
      isEditPage ? $t('subject.subject_detail') : $t('subject.add_new_subject')
    "
  >
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">
                {{ $t("subject.subject_information") }}
              </h4>
            </div>
          </md-card-header>

          <md-card-content>
            <validation-form @on-submit="submitForm">
              <!-- form input -->
              <div class="form-input mb-10">
                <div class="md-layout mt-15">
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="subject_validation.name"
                      name="name"
                    >
                      <label>{{ $t("subject.name") }}</label>
                      <md-input
                        :readonly="isReadOnly"
                        required
                        v-model.trim="formSubject.name"
                        :maxlength="subject_validation.name.maxLength"
                      ></md-input>
                      <span class="md-error" v-if="serverValidations.name">{{
                        serverValidations.name
                      }}</span>
                    </validation-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="subject_validation.subjectCode"
                      name="subject no"
                    >
                      <label>{{ $t("subject.code") }}</label>
                      <md-input
                        :readonly="isReadOnly"
                        v-model="formSubject.code"
                        :maxlength="subject_validation.subjectCode.maxLength"
                      ></md-input>
                    </validation-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label :for="select.name">{{ $t(select.label) }}</label>
                      <md-select
                        :disabled="isReadOnly"
                        :name="select.name"
                        :id="select.name"
                        v-model="formSubject.status"
                        :multiple="select.multiple"
                      >
                        <md-option
                          v-for="option in select.options"
                          :value="option.id"
                          :key="option.id + option.name"
                          >{{ $t(option.name) }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label :for="gradeSelect.name">{{
                        $t(gradeSelect.label)
                      }}</label>
                      <md-select
                        :disabled="isReadOnly"
                        :name="gradeSelect.name"
                        :id="gradeSelect.id"
                        v-model="formSubject.grade_id"
                      >
                        <md-option
                          v-for="option in gradeSelect.options"
                          :value="option.id"
                          :key="option.id + option.name"
                          >{{ option.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <!-- Grade scale -->
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label :for="gradeScaleSelect.name">{{
                        $t(gradeScaleSelect.label)
                      }}</label>
                      <md-select
                        :disabled="isReadOnly"
                        :name="gradeScaleSelect.name"
                        :id="gradeScaleSelect.id"
                        v-model="formSubject.grade_scale_id"
                      >
                        <md-option
                          v-for="option in gradeScaleSelect.options"
                          :value="option.id"
                          :key="option.id + option.name"
                          >{{ option.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <!-- grade scale -->

                  <!-- Credit  -->
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="subject_validation.credit"
                      name="credit"
                    >
                      <label>{{ $t("subject.credit") }}</label>
                      <md-input
                        :readonly="isReadOnly"
                        v-model="formSubject.credit"
                      ></md-input>
                    </validation-field>
                  </div>
                  <!-- Credit  -->

                  <!-- Weight -->
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="subject_validation.weight"
                      name="weight"
                    >
                      <label>{{ $t("subject.weight") }}</label>
                      <md-input v-model.trim="formSubject.weight"></md-input>
                    </validation-field>
                  </div>
                  <!-- Weight -->

                  <!-- Type -->
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="{ required: true }"
                      name="name"
                    >
                      <label>{{ $t(selectType.label) }}</label>
                      <md-select
                        required
                        :disabled="isReadOnly"
                        name="subject type"
                        id="subject type"
                        v-model="formSubject.subject_type_id"
                      >
                        <md-option
                          v-for="option in selectType.options"
                          :value="option.id"
                          :key="option.id + option.name"
                          >{{ capitalizeFirstLetter(option.name) }}
                        </md-option>
                      </md-select>
                    </validation-field>
                  </div>
                  <!-- Type -->

                  <!-- Description -->
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label>{{ $t("common.description") }}</label>
                      <md-input
                        :readonly="isReadOnly"
                        v-model="formSubject.description"
                      ></md-input>
                    </md-field>
                  </div>
                  <!-- Description -->

                  <!--Switch toggle -->
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-switch
                      :disabled="isReadOnly"
                      v-model="isSwitchToggle"
                      @change="changeSwitch(isSwitchToggle)"
                      class="isis-switch-field"
                      >{{ $t("subject.set_rule_for_this_subject") }}
                    </md-switch>
                  </div>
                  <!--Switch toggle -->
                </div>

                <!--  List rule -->
                <div v-if="isSwitchToggle">
                  <p class="title-rule">
                    {{ $t("subject.condition") }}
                  </p>
                  `
                  <div
                    class="list-rule"
                    v-for="(item, index) in formSubject.rules"
                    :key="index"
                  >
                    <div class="md-layout mt-15">
                      <div class="md-layout-item md-size-33 md-small-size-100">
                        <md-field>
                          <label :for="ruleSelect.name">{{
                            $t(ruleSelect.label)
                          }}</label>
                          <md-select
                            :disabled="isReadOnly"
                            :name="ruleSelect.name"
                            :id="ruleSelect.id"
                            required
                            v-model="formSubject.rules[index].type"
                            :multiple="ruleSelect.multiple"
                          >
                            <md-option
                              v-for="option in ruleSelect.options"
                              :value="option.id"
                              :key="option.id + option.name"
                              >{{ $t(option.name) }}
                            </md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <!-- subject 2 -->
                      <div class="md-layout-item md-size-33 md-small-size-100">
                        <validation-field
                          :validations="subject_validation.subject"
                          :name="'subject for rule ' + (index + 1)"
                          type="autocomplete"
                        >
                          <template #default="{ errors }">
                            <isis-autocomplete
                              :isDisabled="isReadOnly"
                              v-model="listSubject2.setVal[index].displayValue"
                              :value.sync="listSubject2.setVal[index].value"
                              :options.sync="listSubject2.options"
                              :refetchOptions="listSubject2.refetchOptions"
                              :search-key="listSubject2.searchKey"
                              :fields="listSubject2.fields"
                              :label="listSubject2.label"
                              :class="{ 'md-invalid': !!errors.length }"
                              required
                            >
                              <span class="md-error" style="top:35px">{{
                                errors[0]
                              }}</span>
                            </isis-autocomplete>
                          </template>
                        </validation-field>
                      </div>
                      <div
                        class="md-layout-item md-size-5 flex items-end justify-center"
                        @click="deleteSubjectRule(index)"
                      >
                        <md-icon class="icon-delete">delete</md-icon>
                      </div>
                    </div>
                    <p class="description-rule ">
                      {{ $t("common.description") }}:
                      {{ setDescription(formSubject.rules[index].type) }}
                    </p>
                  </div>

                  <!-- add subject rule -->
                  <div class="md-layout flex justify-start my-5 mb-8">
                    <md-button
                      :disabled="isReadOnly"
                      @click="addSubjectRule"
                      class="md-success md-simple"
                      style="color: green"
                      >{{ $t("common.add") }}
                    </md-button>
                  </div>
                </div>
              </div>
              <!-- list classes of subject -->
              <slot name="table"></slot>
              <!-- btn -->
              <div class="from-submit">
                <md-button class="md-raised mr-5" @click="goToPreviousPage"
                  >{{ $t("common.cancel") }}
                </md-button>
                <md-button
                  v-if="isEditPage && !isReadOnly"
                  type="submit"
                  class="md-success"
                  >{{ $t("common.update") }}
                </md-button>
                <md-button v-if="!isEditPage" type="submit" class="md-success"
                  >{{ $t("common.add") }}
                </md-button>
              </div>
            </validation-form>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </page-layout>
</template>

<script>
import PageLayout from "../PageLayout.vue";
import { service_names, service_paths } from "@/constants/Services";
import { capitalizeFirstLetter, getId, hasHistory } from "@/helpers/utils";
import { validations } from "@/validations/subjects";
import cloneDeep from "lodash/cloneDeep";
import pick from "lodash/pick";
import { Subject } from "@/constants/Permissions";

const initFormData = () => ({
  name: "",
  description: "",
  status: "Active",
  grade_id: null,
  code: null,
  credit: null,
  weight: 1,
  subject_type_id: null,
  grade_scale_id: null,
  rules: [{ type: "before" }]
});
export default {
  components: { PageLayout },
  props: ["isEditPage", "formEdit", "serverValidations"],
  data() {
    return {
      Subject,
      capitalizeFirstLetter,
      listSubject2: {
        label: "subject.subject_2",
        name: "subject_id",
        setVal: [{ value: "", displayValue: "" }],
        options: [],
        type: "autocomplete",
        fields: {
          text: "name",
          value: "id"
        },
        searchKey: "name__~",
        refetchOptions: this.fetchSubjectOptions
      },
      formSubject: initFormData(),
      isSwitchToggle: false,
      subject_validation: validations,
      defaultSubjectOptions: [],
      isFirstClick: false,
      gradeSelect: {
        label: "common.grade",
        name: "grade",
        value: "",
        type: "select",
        options: []
      },
      subjectSelect: {
        name: "subject",
        value: "",
        type: "select",
        options: []
      },
      gradeScaleSelect: {
        label: "subject.grade_scale",
        name: "subject",
        value: "",
        type: "select",
        options: []
      },
      ruleSelect: {
        label: "subject.rule",
        name: "subject_id",
        value: "",
        type: "select",
        options: [
          {
            id: "before",
            name: "subject.before"
          },
          {
            id: "after",
            name: "subject.after"
          },
          {
            id: "follow",
            name: "subject.follow"
          },
          {
            id: "consecutive",
            name: "subject.consecutive"
          },
          {
            id: "precede",
            name: "subject.precede"
          },
          {
            id: "same_teacher",
            name: "subject.same_teacher"
          },
          {
            id: "same_term",
            name: "subject.same_term"
          },
          {
            id: "different_term",
            name: "subject.different_term"
          }
        ]
      },
      selectType: {
        label: "subject.type",
        name: "type__",
        value: "",
        type: "select",
        options: []
      },
      select: {
        label: "common.status",
        name: "status__",
        value: "",
        type: "select",
        options: [
          {
            id: "Active",
            name: "common.active"
          },
          {
            id: "Inactive",
            name: "common.inactive"
          }
        ]
      }
    };
  },
  created() {
    this.getSubjectType();
    this.fetchSubjectOptions();
    this.fetchSubjectList();
    this.fetchGradesList();
    this.fetchGradeScaleList();
  },
  watch: {
    "formSubject.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    }
  },
  computed: {
    isReadOnly() {
      return (
        this.isEditPage && !this.$can(Subject.actions.edit, Subject.subject)
      );
    }
  },
  methods: {
    setDescription(type) {
      if (type === "before" || type === "after") {
        return this.$t("subject.type_before_or_after", { type: type });
      } else if (type === "precede") {
        return this.$t("subject.type_precede");
      } else if (type === "follow") {
        return this.$t("subject.type_follow");
      } else if (type === "consecutive") {
        return this.$t("subject.type_consecutive");
      } else if (type === "same_teacher") {
        return this.$t("subject.type_same_teacher");
      } else if (type === "same_term") {
        return this.$t("subject.type_same_term");
      } else if (type === "different_term") {
        return this.$t("subject.type_different_term");
      }
    },
    addSubjectRule() {
      this.fetchSubjectOptions();
      this.formSubject.rules.push({
        type: "before"
      });
      this.listSubject2.setVal.push({
        value: this.defaultSubjectOptions[0].id,
        displayValue: this.defaultSubjectOptions[0].name
      });
    },
    getSubjectType() {
      this.$axios
        .get(`${service_names.school}/subject-types`, { limit: 100 })
        .then(response => {
          if (response.data) {
            this.selectType.options = response.data.data;
          }
        });
    },
    deleteSubjectRule(index) {
      if (this.formSubject.rules.length !== 1) {
        this.formSubject.rules.splice(index, 1);
        this.listSubject2.setVal.splice(index, 1);
      } else {
        this.formSubject.rules.type = "before";
        this.listSubject2.setVal.displayValue = this.defaultSubjectOptions[0].name;
        this.listSubject2.setVal.value = this.defaultSubjectOptions[0].id;
        this.isSwitchToggle = false;
      }
    },
    changeSwitch(bool) {
      if (bool) {
        if (this.formSubject.rules.length === 0) {
          this.addSubjectRule();
        }
      }
    },
    submitForm() {
      if (this.isSwitchToggle) {
        this.formSubject.rules.forEach((item, index) => {
          item.relevance_subject_id = this.listSubject2.setVal[index].value;
        });
      } else {
        this.formSubject.rules = [];
      }
      this.$emit("on-submit", this.formSubject);
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    fetchGradesList() {
      this.$axios.get(service_paths.grades, { limit: 9999 }).then(response => {
        this.gradeSelect.options = response.data.data;
      });
    },
    fetchSubjectList() {
      this.$axios
        .get(service_paths.subjects, { limit: 10000 })
        .then(async response => {
          this.subjectSelect.options = cloneDeep(response.data.data);
          this.defaultSubjectOptions = response.data.data;
          this.resetFormRuleSelect();
        });
    },
    resetFormRuleSelect() {
      if (this.isEditPage) {
        this.formSubject = pick(this.formEdit, Object.keys(this.formSubject));
        this.formSubject.rules.forEach((item, index) => {
          return (this.formSubject.rules[index] = pick(
            this.formSubject.rules[index],
            Object.keys({ type: "", relevance_subject_id: "" })
          ));
        });
        if (this.formEdit.rules.length > 0) {
          this.isSwitchToggle = true;
          this.listSubject2.setVal = [];
          this.formEdit.rules.forEach((item, index) => {
            this.listSubject2.setVal.push({
              value: item.relevance_subject_id,
              displayValue: this.defaultSubjectOptions.find(i => {
                return i?.id === item.relevance_subject_id;
              })?.name
            });
          });
        } else {
          this.listSubject2.setVal = [];
          this.listSubject2.setVal.push({
            value: this.defaultSubjectOptions[0].id,
            displayValue: this.defaultSubjectOptions[0].name
          });
        }
      } else {
        this.formSubject.rules = [];
        this.formSubject.rules.push({
          type: this.ruleSelect.options[0].id,
          relevance_subject_id: this.subjectSelect.options[0].id
        });
      }
    },
    fetchSubjectOptions(queryObj) {
      const currentId = this.$route.params.id;
      return this.$axios
        .get(
          `${service_paths.subjects}`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.defaultSubjectOptions = [];
          response.data.data.forEach(subject => {
            if (getId(subject) !== currentId) {
              this.defaultSubjectOptions.push({
                id: getId(subject),
                name: subject.name
              });
            }
          });
          this.createSubjectOption(this.defaultSubjectOptions);
        });
    },
    createSubjectOption(options) {
      this.listSubject2.options = options;
      if (!this.isEditPage && this.isFirstClick === false) {
        this.listSubject2.setVal.forEach(item => {
          item.displayValue = options[0].name;
          item.value = options[0].id;
        });
        this.isFirstClick = true;
      }
    },
    fetchGradeScaleList() {
      this.$axios
        .get(service_paths.grade_scales, { limit: 9999 })
        .then(response => {
          this.gradeScaleSelect.options = response.data.data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-checkbox {
  display: flex;
}

.md-checkbox {
  width: 180px;
  margin-right: 0;
}

.checkbox-name {
  color: gray;
  font-size: 16px;
}

.md-input {
  width: 230px;
}

.from-submit {
  display: flex;
  justify-content: center;
}

.md-error {
  top: 35px;
}

.md-title {
  font-size: 18px;
}

.title-rule {
  padding: 14px;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}

.subject-selected-title {
  line-height: 14px;
  font-size: 14px;
}

.subject-selected-label {
  font-size: 12px;
  line-height: 12px;
  top: 20px;

  color: #aaa;
}

.description-rule {
  padding: 14px;
  font-size: 12px;
  line-height: 12px;
  color: #aaa;
}

.icon-delete {
  color: red !important;
  cursor: pointer;
}

.md-field {
  margin-bottom: 0px !important;
}
</style>
